import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ion-text-center today-header" }
const _hoisted_2 = { class: "white-bold" }
const _hoisted_3 = {
  key: 0,
  class: "news-section"
}
const _hoisted_4 = { class: "news-grid" }
const _hoisted_5 = {
  key: 0,
  class: "news-skeleton-wrapper"
}
const _hoisted_6 = ["alt", "src"]
const _hoisted_7 = { class: "news-overlay" }
const _hoisted_8 = { class: "news-content" }
const _hoisted_9 = { class: "news-title" }
const _hoisted_10 = { class: "news-description" }
const _hoisted_11 = { class: "news-skeleton-wrapper" }
const _hoisted_12 = { class: "news-overlay" }
const _hoisted_13 = { class: "news-content" }
const _hoisted_14 = { class: "programs-section" }
const _hoisted_15 = { class: "programs-grid" }
const _hoisted_16 = { class: "program-image-container" }
const _hoisted_17 = {
  key: 0,
  class: "program-skeleton-wrapper"
}
const _hoisted_18 = ["src", "alt", "onLoad", "onError"]
const _hoisted_19 = { class: "program-overlay" }
const _hoisted_20 = { class: "program-description" }
const _hoisted_21 = {
  key: 1,
  class: "offline-section"
}
const _hoisted_22 = { class: "offline-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: _normalizeClass(['main-background', 'today-content']),
        fullscreen: true,
        "scroll-y": true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _ctx.reloadNews
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content, { refreshingSpinner: "bubbles" })
            ]),
            _: 1
          }, 8, ["onIonRefresh"]),
          _createElementVNode("header", _hoisted_1, [
            _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "header-title white-bold" }, "Сегодня", -1)),
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.now), 1)
          ]),
          (_ctx.todayNews.length > 0 || _ctx.isLoadingNews)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "section-title" }, "Новости", -1)),
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.todayNews.slice(0, _ctx.isMobile ? 2 : 4), (todayNew) => {
                    return (_openBlock(), _createBlock(_component_ion_card, {
                      key: todayNew.id,
                      class: "news-card"
                    }, {
                      default: _withCtx(() => [
                        (!todayNew.imagePath && _ctx.isLoadingNews)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createVNode(_component_ion_skeleton_text, {
                                animated: true,
                                style: {"width":"100%","height":"100%"}
                              })
                            ]))
                          : (todayNew.imagePath)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                alt: `news-image-${todayNew.id}`,
                                src: todayNew.imagePath,
                                class: "news-image",
                                onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onNewsImageLoad && _ctx.onNewsImageLoad(...args))),
                                onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNewsImageError && _ctx.onNewsImageError(...args)))
                              }, null, 40, _hoisted_6))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("h3", _hoisted_9, _toDisplayString(todayNew.title || 'Добро пожаловать в Лигу Тренеров'), 1),
                            _createElementVNode("p", _hoisted_10, _toDisplayString(todayNew.content || ''), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (_ctx.todayNews.length === 0 && _ctx.isLoadingNews)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((_ctx.isMobile ? 2 : 4), (n) => {
                        return (_openBlock(), _createBlock(_component_ion_card, {
                          key: `news-skeleton-${n}`,
                          class: "news-card"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_ion_skeleton_text, {
                                animated: true,
                                style: {"width":"100%","height":"100%"}
                              })
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"80%","height":"20px","margin-bottom":"8px"}
                                }),
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"60%","height":"16px"}
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      }), 128))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "section-title" }, "Программы", -1)),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePrograms, (program) => {
                return (_openBlock(), _createBlock(_component_ion_card, {
                  key: program.shortName,
                  class: "program-card",
                  onClick: ($event: any) => (_ctx.navigateToProgram(program))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      (!_ctx.programLogos[program.shortName] && _ctx.isLoadingLogos)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_ion_skeleton_text, {
                              animated: true,
                              style: {"width":"100%","height":"100%"}
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _ctx.programLogos[program.shortName] || _ctx.fallbackLogo,
                            alt: program.name,
                            class: "program-image",
                            onLoad: ($event: any) => (_ctx.onProgramImageLoad(program.shortName)),
                            onError: ($event: any) => (_ctx.onProgramImageError(program.shortName))
                          }, null, 40, _hoisted_18)),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("p", _hoisted_20, _toDisplayString(program.description), 1)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ])
          ]),
          (_ctx.globalContext.offlineMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.cloudOffline,
                    class: "offline-icon"
                  }, null, 8, ["icon"]),
                  _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "offline-title" }, "РЕЖИМ ОФФЛАЙН", -1)),
                  _createVNode(_component_ion_button, {
                    class: "reconnect-button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reconnect())),
                    disabled: _ctx.reconnecting
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.refreshOutline
                      }, null, 8, ["icon"]), [
                        [_vShow, !_ctx.reconnecting]
                      ]),
                      _withDirectives(_createVNode(_component_ion_spinner, { name: "bubbles" }, null, 512), [
                        [_vShow, _ctx.reconnecting]
                      ])
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}